export enum IstatMode {
  IstatModeDelete = 'ISTAT_MODE_DELETE',
  IstatModeEdit = 'ISTAT_MODE_EDIT',
  IstatModeNew = 'ISTAT_MODE_NEW',
  IstatModeStill = 'ISTAT_MODE_STILL',
  IstatModeTax = 'ISTAT_MODE_TAX',
}
